import { lazyLoad } from 'utils/loadable';

export const BannerSortListPage = lazyLoad(
  () => import('./index'),
  module => module.BannerSortListPage,
);
